import { Component, OnInit } from '@angular/core';
import { SurveyfeedbackService } from './service/surveyfeedback.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../components/login/service/login.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-survey-feedback',
  templateUrl: './survey-feedback.component.html',
  styleUrls: ['./survey-feedback.component.scss']
})
export class SurveyFeedbackComponent implements OnInit {

  spinner:boolean=false;
  feedBackDataList:any=[];
  modalScreenSize:any;
  reasonData:any;
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  displayTranscriptModal = 'none';
  userDetails:any;
  constructor(private surveyfbService:SurveyfeedbackService,private service:LoginService,private router:Router) { }

  ngOnInit(): void {
      let user = localStorage.getItem("user");
      if(user){
        var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
        this.userDetails = JSON.parse(data);
        if(this.userDetails['cli_code']['$oid'] !='5f434c0d93bd2600072a87e4'){
          this.router.navigateByUrl('/main/unauthorized');
        }
      }   
     this.getFeedbackData();
  }


  getFeedbackData(){
     this.spinner = true;
       this.surveyfbService.getSurveyFeedback().subscribe((result:any)=>{
        this.spinner = false;
            this.feedBackDataList=result['data'];
          
          
       },(error:HttpErrorResponse)=>{
        this.spinner = false;
     });
  }

  showMinimizedModal(modal:any){

  }

  modalFullScreen(size:any){
    if (size === 'max') {
      this.modalScreenSize = 'modal-fullscreen';
    }
    if (size === 'min') {
      this.modalScreenSize = '';
    }
  }

  

  clearKeywordDetailsTranscriptModal(){

  }

  getFeedback(data:any){
  this.reasonData = data['ISSUE_CATEGORY'];
  }

}
